import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/layout/PrivateRoute';
import LandingPage from './components/landing/LandingPage';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import Dashboard from './components/dashboard/Dashboard';
import PurchaseLicense from './components/payment/PurchaseLicense';
import Licenses from './components/licenses/Licenses';
import DemoMode from './components/auth/DemoMode';
import AdminPanel from './components/admin/AdminPanel';

function App() {
  // Check if Firebase is properly configured
  const isFirebaseConfigured = process.env.REACT_APP_FIREBASE_API_KEY && 
    process.env.REACT_APP_FIREBASE_API_KEY !== 'your_api_key_here' &&
    process.env.REACT_APP_FIREBASE_API_KEY !== 'demo-api-key';

  if (!isFirebaseConfigured) {
    return (
      <Router>
        <div className="App">
          <Routes>
            <Route path="*" element={<DemoMode />} />
          </Routes>
        </div>
      </Router>
    );
  }

  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/purchase" 
              element={
                <PrivateRoute>
                  <PurchaseLicense />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/licenses" 
              element={
                <PrivateRoute>
                  <Licenses />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <PrivateRoute>
                  <AdminPanel />
                </PrivateRoute>
              } 
            />
            
            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
